<script setup>
import { onMounted, useSlots, ref, onBeforeMount } from 'vue';

const props = defineProps({
  pauseBetweenTicks: {
    type: String,
    default: '3000',
  },
});

const slots = useSlots();
const counterRef = ref(0);
const totalSlots = ref(0);
const slotKeys = ref([]);
const animPause = parseInt(props.pauseBetweenTicks);
const canAnimate = ref(false);
const isPaused = ref(false);

const removeEl = (id) => {
  stepHandler('stop');
  const notificationIndex = slotKeys.value.indexOf(id);
  const newSlotKeys = slotKeys.value.filter((entry) => {
    return entry !== id;
  });
  slotKeys.value = newSlotKeys;

  if (notificationIndex === slotKeys.value.length) {
    counterRef.value = 0;
  }

  stepHandler('start');
};

const mouseOverHandler = () => {
  isPaused.value = true;
};

const focusHandler = () => {
  isPaused.value = true;
};

const mouseLeaveHandler = () => {
  isPaused.value = false;
};

const blurHandler = (e) => {
  const receivedFocus = e?.relatedTarget;
  if (receivedFocus && receivedFocus.closest('.notification')) {
  } else {
    isPaused.value = false;
  }
};

let stepInterval = null;
const stepHandler = (action) => {
  if (action === 'start') {
    stepInterval = setInterval(() => {
      let newCounterValue = counterRef.value + 1;
      if (newCounterValue >= slotKeys.value.length) {
        newCounterValue = 0;
      }

      if (!isPaused.value) {
        counterRef.value = newCounterValue;
      }
    }, animPause);
  }
  if (action === 'stop') {
    clearInterval(stepInterval);
  }
};

onBeforeMount(() => {
  slotKeys.value = Object.keys(slots);
  totalSlots.value = slotKeys.value.length;
  if (totalSlots.value > 1) {
    canAnimate.value = true;
  }
});

onMounted(() => {
  if (canAnimate.value === true) {
    stepHandler('start');
  }
});
</script>

<template>
  <ul class="notificationTicker">
    <li
      @mouseover="mouseOverHandler"
      @mouseleave="mouseLeaveHandler"
      @focus="focusHandler"
      @blur="blurHandler"
    >
      <slot
        :name="slotKeys[counterRef]"
        :removeEl="removeEl"
        :focusHandler="focusHandler"
        :blurHandler="blurHandler"
      />
    </li>
  </ul>
</template>
